import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const TaboolaIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-taboola${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    x={x}
    y={y}
  >
    <title>Taboola</title>
    <path
      d="M5.1936 9.18464C2.98046 9.17186 1.99013 7.70184 2.00007 6.06769C2.00966 4.43324 3.01633 2.98682 5.22942 3.00013C7.44252 3.01235 8.4329 4.47072 8.42314 6.10516C8.41337 7.73908 7.4067 9.19738 5.1936 9.18464ZM5.22022 4.63405C4.36874 4.62892 4.25041 5.45697 4.24668 6.0807C4.24332 6.70473 4.35172 7.54553 5.20281 7.55072C6.05376 7.55529 6.1726 6.71665 6.17631 6.09186C6.17989 5.46763 6.07131 4.63868 5.22022 4.63405Z"
      fill="#385BB2"
      id="icon-logo-1-fill"
    />
    <path
      d="M10.7699 9.18512C8.55728 9.17181 7.56709 7.70179 7.57685 6.06771C7.58592 4.43372 8.59313 2.98677 10.8059 3.00008C13.0188 3.01286 14.0092 4.47116 14 6.10511C13.9902 7.73956 12.983 9.1975 10.7699 9.18512ZM10.7965 4.634C9.94553 4.62887 9.82722 5.45691 9.82368 6.08114C9.81961 6.70524 9.92819 7.54554 10.7796 7.55067C11.63 7.5558 11.749 6.71656 11.7526 6.09237C11.7562 5.46807 11.6474 4.63863 10.7965 4.634Z"
      fill="#385BB2"
      id="icon-logo-1-fill"
    />
    <path
      d="M2.84278 9.18509C4.43823 9.89784 6.09381 10.2143 7.89768 10.2246C9.79272 10.2358 11.2298 9.87795 13.0491 9.18509L13.0384 11.1483C11.4102 11.9557 9.64445 12.3911 7.88491 12.381C5.96733 12.3696 4.58529 11.9758 2.83093 11.1483L2.84278 9.18509Z"
      fill="#385BB2"
      id="icon-logo-1-fill"
    />
  </OpticksSvgElement>
);

export default TaboolaIcon;
